import React from 'react';
import RealEstateFields from '../investment-fields/RealEstateFields';
import GoldFields from '../investment-fields/GoldFields';
import ETFFields from '../investment-fields/ETFFields';
import StockFields from '../investment-fields/StockFields';
import BondFields from '../investment-fields/BondFields';
import MutualFundFields from '../investment-fields/MutualFundFields';
import PrivateEquityFields from '../investment-fields/PrivateEquityFields';
import ConvertibleFields from '../investment-fields/ConvertibleFields';
import SAFEFields from '../investment-fields/SAFEFields';
import CryptoFields from '../investment-fields/CryptoFields';

const TYPE_COMPONENT_MAP = {
  quoted_stocks: { Component: StockFields, needsConfig: true, needsSetConfig: true },
  government_bond: { Component: BondFields },
  corporate_bond: { Component: BondFields },
  fixed_deposit: { Component: BondFields },
  treasury_bill: { Component: BondFields },
  mutual_fund: { Component: MutualFundFields, needsConfig: true, needsSetConfig: true },
  private_equity: { Component: PrivateEquityFields },
  convertible: { Component: ConvertibleFields },
  safe: { Component: SAFEFields, needsConfig: true },
  crypto: { Component: CryptoFields },
  real_estate: { Component: RealEstateFields },
  etf: { Component: ETFFields },
  gold: { Component: GoldFields },
};

const TypeSpecificFields = ({ formData, onFieldChange, config, setConfig }) => {
  const entry = TYPE_COMPONENT_MAP[formData.type];
  if (!entry) return null;

  const { Component, needsConfig, needsSetConfig } = entry;
  const props = { formData, onFieldChange };
  if (needsConfig) props.config = config;
  if (needsSetConfig) props.setConfig = setConfig;

  return <Component {...props} />;
};

export default TypeSpecificFields;
